// extracted by mini-css-extract-plugin
module.exports = {"smooth":"_view_smooth__3CTGd","note":"_view_note__1qF1H","outlined":"_view_outlined__8DCh-","raised":"_view_raised__3sTcS"};